import arika from "../../../../public/projects/Birla/projects/arika.webp";
import logo from "../../../../public/projects/Birla/logo/logo.png";

//Birla Arika
import overviewImage_arika from "../../../../public/projects/Birla/images/gurugram/arika/Overview/1.webp";
import bannerDesktopImage_arika from "../../../../public/projects/Birla/images/gurugram/arika/Banner/1.webp";
import bannerMobileImage_arika from "../../../../public/projects/Birla/images/gurugram/arika/Banner/2.webp";
import siteVisitBannerImage_arika from "../../../../public/projects/Birla/images/gurugram/arika/SiteVisitBanner/1.webp";
import Location_arika from "../../../../public/projects/Birla/images/gurugram/arika/Location/L1.webp";
import Hightlights_arika from "../../../../public/projects/Birla/images/gurugram/arika/Highlights/1.webp";
import image1BHK_arika from "../../../../public/projects/Birla/images/gurugram/arika/floorplan/1.webp";
import image2BHK_arika from "../../../../public/projects/Birla/images/gurugram/arika/floorplan/2.webp";

import location_arika from "../../../../public/projects/Birla/images/gurugram/arika/Overview/l.png";
import cal_arika from "../../../../public/projects/Birla/images/gurugram/arika/Overview/c.png";
import newlaunch_arika from "../../../../public/projects/Birla/images/gurugram/arika/Overview/n.png";
import g1_arika from "../../../../public/projects/Birla/images/gurugram/arika/Gallery/1.webp";
import g2_arika from "../../../../public/projects/Birla/images/gurugram/arika/Gallery/2.webp";
import g3_arika from "../../../../public/projects/Birla/images/gurugram/arika/Gallery/3.webp";
import g4_arika from "../../../../public/projects/Birla/images/gurugram/arika/Gallery/4.webp";
import g5_arika from "../../../../public/projects/Birla/images/gurugram/arika/Gallery/5.webp";

export const developersBirla = {
  name: `Birla Estates Properties in Gurugram`,
  properties: [
    {
      name: "Birla - Arika",
      image: arika,
      price: "On Request",
      location: "Sector 31",
      bed: "4 BHK",
      state: "Gurugram",
      developer: "Birla Estates",
      size: "....",
      url: `/birla-arika-sector-31-gurugram`,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry",
        to_email: "leads@gurugram-property.com",
      },
    },
  ],
};
export const headerData = {
  logo: logo,
  logo,
  data: {
    experience: `2017`,
    projects: `118`,
    ongoingprojects: `10`,
  },
  about: `Birla Estates Private Limited is completely controlled by Century Textiles and Industries Limited. In 2017, it became the focus of premium providing residential properties, developments, and commercial mixed use through owned land parcels and joint ventures. Being a part of Aditya Birla Group, the company is into real estate business. It was founded in 2017 and is head quartered in Mumbai and has regional head offices in NCR and Bangalore. The company has approximately 20 million square feet in the company's diverse portfolio which includes grade A commercial spaces and far more residential projects than that. Moreover, the company have arrangements and deals in places with other reputable and trusted real estate developer firms such as DB Realty Limited. Birla Estates goal is to create spaces that enrich lives and LIFEDESIGNED philosophy aims to transform the life of the customers adding the peak human centric lifestyle for boosted efficiency. Through sustainability and efficient design, it becomes central to the business.

`,
};
export const projectsbirla = {
  arika: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_arika,
      bannerMobileImage: bannerMobileImage_arika,
      textOverlay: "",
      data: {
        title: "Birla - Arika",
        subtitle: "Sector 31, Gurgaon",
        starting_price: "On Request",
        rerano: "GGM/914/646/2025/17",
        payment_plan: "CLP",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Birla Arika At Sector 31, Gurgaon",
      description: [
        `Birla Estates, the real estate arm of the Aditya Birla Group, proudly introduces its latest premium development in Sector 31,
         Gurugram, along NH-48. This landmark project combines modern architecture, superior craftsmanship, and sustainable living, setting a 
         new benchmark in urban development with an impeccable blend of residential elegance and commercial excellence.
      Strategically located in the heart of Gurugram, Birla Estates Sector 31 offers seamless connectivity to key areas of the city. 
      It is in close proximity to major commercial hubs such as City Centre 29, Signature Towers, 32nd Avenue, and Crowne Plaza.
       The project enjoys excellent accessibility via NH-48 and the Metro, while its closeness to Indira Gandhi International Airport
        makes it a prime choice for professionals and travelers alike.   `,
      ],
      image: overviewImage_arika,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_arika,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_arika,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_arika,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_arika,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "4 BHK",
          area: "2350 sq. ft.",
          price: "On Request",
        },
        {
          type: "4 BHK",
          area: "2356 sq. ft.",
          price: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "4 BHK",
        area: "2350 sq. ft.",
        price: "On Request",
        image: image1BHK_arika,
      },
      {
        type: "4 BHK",
        area: "2356 sq. ft.",
        price: "On Request",
        image: image2BHK_arika,
      },
    ],

    highlights: {
      images: Hightlights_arika,
      tagline: "Highlights",
      features: [
        "Total Towers : 6 + 1 Iconic.",
        "Total Land Parcel : 13.25 Acres .",
        "T8.5 Acre Green Area.",
        "2 Car Parking Each in Basement.",
        "High Speed Elevators.",
      ],
    },

    location: {
      image: Location_arika,
      data: [
        {
          airport: {
            distance_time: "14 Km",
            name: "IGI Airport",
          },
          school: {
            distance_time: "98 m",
            name: "Rishi Public School",
          },
          railwayormetro: {
            distance_time: "8.8 Km",
            name: "Gurgaon railway sation",
          },
          hospital: {
            distance_time: "1.4 Km",
            name: "Shivam Hospital",
          },
          mall: {
            distance_time: "3.4 Km",
            name: "Star Mall",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_arika },
        { image: g2_arika },
        { image: g3_arika },
        { image: g4_arika },
        { image: g5_arika },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Birla Arika, kindly share more details.",
    },

    faq: [
      {
        question: "What is the name of the project?",
        answer: `The project is called Ekta Eden 62.`,
      },
      {
        question: "Who is the developer of Ekta Eden 62?",
        answer: `The project is developed by Ekta World.`,
      },
      {
        question: "Where is Ekta Eden 62 located?",
        answer: `It is located in Juhu, Mumbai.`,
      },
      {
        question: "What types of apartments are available in Ekta Eden 62?",
        answer: `The project offers 4 BHK and 5 BHK apartments.`,
      },
      {
        question: "What is the area of the 4 BHK apartments in Ekta Eden 62?",
        answer: `The area of the 4 BHK apartments is on request.`,
      },
      {
        question: "What is the area of the 5 BHK apartments in Ekta Eden 62?",
        answer: `The area of the 5 BHK apartments is on request.`,
      },
      {
        question: "What is the starting price of apartments in Ekta Eden 62?",
        answer: `The starting price is on request.`,
      },
      {
        question: "What is the current status of Ekta Eden 62?",
        answer: `It is a New Launch project.`,
      },
      {
        question: "Which city is Ekta Eden 62 located in?",
        answer: `It is in Mumbai.
`,
      },
      {
        question:
          "What is the configuration of the largest apartment in Ekta Eden 62?",
        answer: `The largest apartment configuration is 5 BHK.`,
      },
    ],
    similar: {},
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
       api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
       source_id: 11,
       sub_source_id: 130,
       builder_id: `103`,
       project_id: `477`,
       subject: "Property Station enquiry", // Add or update the subject here
       to_email: "leads@gurugram-property.com",
     },
  },
};
